export const getAllOfferLetterQuery = `
query employeeOfferLetterByAll{
  employeeOfferLetterByAll {
    success
    error
    message
    data {
      id
      fullName
      department
      designation
      doj
      ctc
      salaryStructure {
        id
        structureName
      }
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
      offerLetterPdf
      isDeleted
      createdAt
      updatedAt
    }
  }
}`

export const allDepartmentQuery = `
query {
    allDepartment {
    id
    departmentName
    departmentCode
    }
}`;

export const allDesignationQuery = ` 
query{
    allDesignation{
        id
        departmentName
        designation
        lastUpdate
    }
}`;

export const allSalaryStructuresQuery = `
query allsalarystructure{
    salaryStructures {
        id
        structureName
        salaryType
        components {
        id
        percentage
        amount
        type
        calculatedFrom
        }
    }
}`;

export const submitOfferLetterQuery =`
    mutation CreateEmployeeOfferLetter(
        $full_name: String!
        $department: String!
        $designation: String!
        $doj: Date!
        $ctc: Float!
        $salary_structure_id: ID!
        $basic_percentage: Float!
    ) {
        createEmployeeOfferLetter(
            fullName: $full_name
            department: $department
            designation: $designation
            doj: $doj
            ctc: $ctc
            salaryStructureId: $salary_structure_id
            basicPercentage: $basic_percentage
        ) {
            success
            error
            message
            data {
                id
                fullName
                department
                designation
                doj
                offerLetterPdf
                ctc
                basicPercentage
                gross
                totalDeductions
                totalBenefits
                netPay
                overallSum
                difference
                breakdown
            }
        }
    }
`;

export const updateOfferLetterQuery =`
mutation UpdateEmployeeOfferLetter(
  $id: ID!
  $full_name: String
  $department: String
  $designation: String
  $doj: Date
  $ctc: Float
  $salary_structure_id: ID
  $basic_percentage: Float
  $offer_letter_pdf: Upload
) {
  updateEmployeeOfferLetter(
    id: $id
    fullName: $full_name
    department: $department
    designation: $designation
    doj: $doj
    ctc: $ctc
    salaryStructureId: $salary_structure_id
    basicPercentage: $basic_percentage
    offerLetterPdf: $offer_letter_pdf
  ) {
    success
    error
    message
    data {
      id
      fullName
      department
      designation
      doj
      offerLetterPdf
      ctc
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
    }
  }
}
 `;

export const getOfferLetterByIdQuery = `
query employeeOfferLetterById($id: ID!) {
  employeeOfferLetterById(id: $id) {
    success
    error
    message
    data {
      id
      fullName
      department
      designation
      doj
      ctc
      salaryStructure {
        id
        structureName
        salaryType
      }
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
      offerLetterPdf
      isDeleted
      createdAt
      updatedAt
    }
  }
}`;

export const deleteEmployeeOfferLetterQuery = `
    mutation DeleteEmployeeOfferLetter($id: ID!) {
        deleteEmployeeOfferLetter(id: $id) {
            success
            message
        }
    }
`